<template>
  <v-container>
    <v-row class="pa-4 ma-0 contenedor align-content-center flex-wrap d-flex">
      <v-col align="center" justify="space-around" md="12" sm="12" class="pa-0 ma-0">
        <h1>{{ $STR.tituloCentroAyuda }} {{ sProducto }}</h1>
      </v-col>
    </v-row>
    <v-row class="pa-4 ma-0 nav-contenedor-primary">
      <v-col v-if="sModulo != undefined" lg="12" md="12" sm="12" class="pa-0 ma-0" >
        <h5>
          <router-link :to="routeDashboard">{{ $STR.navVistaPrincipal }}</router-link>
          <v-icon>mdi-chevron-right</v-icon>
          <router-link :to="routeModulo"
            >{{ $STR.navModulo }} {{ sModulo }}
          </router-link>
          > <b>{{ oPregunta.Pregunta }}</b>
        </h5>
      </v-col>
      <v-col v-else lg="12" md="12" sm="12" class="pa-0 ma-0">
        <h5>
          <router-link :to="routeDashboard"
            >{{ $STR.navVistaPrincipal }}
          </router-link>
          >
          <b>{{ oPregunta.Pregunta }}</b>
        </h5>
      </v-col>
    </v-row>
    <v-row class="pa-4 ma-0 align-content-center flex-wrap d-flex">
      <v-col align="center" justify="space-around" lg="12" md="12" sm="12" class="pa-0 ma-0" >
        <h2>{{ oPregunta.Pregunta }}</h2>
      </v-col>
    </v-row>
    <v-row class="pa-4 ma-0 flex-wrap d-flex">
      <v-col align="center" justify="space-around" lg="12" md="12" sm="12" class="pa-4 ma-1">
        <v-chip class="pa-4 ma-1" color="primary" pill>{{ oPregunta.Tecnologia }}</v-chip>
        <v-chip class="pa-4 ma-1" color="primary" pill>{{ oPregunta.Categoria }}</v-chip>
      </v-col>
    </v-row>
    <v-row class="pa-4 ma-0 flex-wrap d-flex">
      <v-col justify="space-around" cols="12" lg="12" md="12" sm="12" class="pa-4 ma-2">
        <div v-html="oPregunta.Respuesta"></div>
      </v-col>
      <v-col align="center" justify="space-around" cols="12" lg="12" md="12" sm="12" class="pa-0 ma-0" >
        <v-divider class="ma-4"/>
        {{ $STR.textEncuesta }}
      </v-col>
      <v-col v-if="!isCalificado" align="center" justify="space-around" cols="12" lg="12" md="12" sm="12" class="pa-0 ma-0" >
        <v-icon color="primary" class="pa-4 ma-1" @click="onClickCalificar('1')" x-large >mdi-thumb-up-outline</v-icon>
        <v-icon color="primary" class="pa-4 ma-1" @click="onClickCalificar('0')" x-large >mdi-thumb-down-outline</v-icon>
        <v-divider class="ma-4"/>
      </v-col>
      <v-col v-else align="center" justify="space-around" cols="12" lg="12" md="12" sm="12" class="pa-0 ma-0" > 
        <p>{{ $STR.textCalificacionExitosa }}</p>
        <v-divider class="ma-4"/>
      </v-col>
      <v-col align="center" justify="space-around" cols="12" lg="12" md="12" sm="12" class="pa-0 ma-0" > 
        <v-btn rounded color="primary" elevation="2" @click="__onVolver" >
          <v-icon left>mdi-chevron-left</v-icon>
          {{ $STR.btnVolver }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axiosServices from "@/services/axiosServices.js";

// import { mixFunciones } from "@/mixins/funciones.js";

export default {
  name: "pregunta-modulo-ayuda",
  // mixins: [mixFunciones],
  components: {},
  mounted() {
    this.onLoadData();
  },
  data() {
    return {
      routeDashboard:
        "/Inicio/centro-de-ayuda/dashboard/producto/" +
        sessionStorage.producto +
        "?tecnologia=" +
        sessionStorage.tecnologia +
        "&perfil=" +
        sessionStorage.perfil +
        "&usuario=" +
        sessionStorage.usuario +
        "&codigo=" +
        sessionStorage.codigo,
      routeModulo:
        "/Inicio/centro-de-ayuda/dashboard/producto/" +
        sessionStorage.producto +
        "/modulo/" +
        sessionStorage.modulo,
      sToken: this.$store.state.token,
      sProducto: "",
      sModulo: sessionStorage.sModulo,
      oPregunta: JSON.parse(sessionStorage.item),
      idVisita: 0,
      isCalificado: false,
    };
  },
  methods: {
    async onLoadData() {
      this.cargando = true;
      try {
        let usuario = sessionStorage.usuario || this.$store.state.idUser;
        // si no existe un usuario enviaremos 0
        if(typeof usuario === 'undefined' || usuario === '' || usuario === null) usuario = '0';

        let oPost = {
          usuario: usuario,
          perfil: sessionStorage.perfil || this.$store.state.idPerfil || '4',
          codigo: sessionStorage.codigo
        };
        let aResponse = await axiosServices.postConfiguration(`/base_conocimientos/pregunta/${this.oPregunta.idBC_Preguntas}/visita`, oPost, true, `app=${this.sApp}&token=${this.sToken}`);

        this.idVisita = aResponse.aData;
        this.cargando = false;
      } catch (error) {
        this.cargando = false;
      }
    },
    async onClickCalificar(idCalificacion) {
      let usuario = sessionStorage.usuario || this.$store.state.idUser;
        // si no existe un usuario enviaremos 0
        if(typeof usuario === 'undefined' || usuario === '' || usuario === null) usuario = '0';
      let oPost = {
        usuario: usuario,
        perfil: sessionStorage.perfil || this.$store.state.idPerfil || '4', // 4 externo
        codigo: sessionStorage.codigo,
        calificacion: idCalificacion,
      };
      let aResponse = await axiosServices.putConfiguration( `/base_conocimientos/pregunta/visita/${this.idVisita}`, oPost, true, `app=${this.sApp}&token=${this.sToken}`);
      this.idVisita = aResponse.aData;
      this.isCalificado = true;
      this.cargando = false;
    },
    __onVolver() {
      // this.$router.go(-1)
      this.$router.push({ path: this.routeDashboard })
    }
  },
};
</script>
